import UserGroupsView from './UserGroupsView';

const views = {
  UserGroupsView,
};
export default views;
